import { formatMomentShort } from 'utils/date'

import { CARRIAGE_TYPE_MAIN, CARRIAGE_TYPE_ON, CARRIAGE_TYPE_PRE } from '../domain/CarriagePlan'
import { getPdadEventCode } from '../domain/PdadEvent'
import { PDAD_DELIVERY, PdadStepsSequence } from '../domain/PdadTypes'
import { TTransportOrCarriageMode } from '../domain/TransportMode'
import { ITimestampJSON } from '../domain/TransportPlanTimestamp'
import { TTransportType } from '../domain/TransportType'
import { tpMileStoneUI } from '../view/TPPartials'
import {
  getPdadEvents,
  getPdadMilestones,
  getProgressPdad,
  ITransportPlanInformation,
  ProgressPdad,
  TProgressPdadMap,
} from './PDAD'
import { getContainersPlans, getContainersTpSortedByActual } from './TPContainersPlans'
import { ICargoProcess, ICarriagePlan, ITransportPlan2 } from './TransportPlan2'
import { getAllEvents } from './transportPlanEventUtils'
import { getAllMilestones } from './transportPlanMilestoneUtils'

const { arrivalPodUI, deliveryUI, departureAirportUI, departurePolUI, destinationAirportUI, pickupUI, cargoReadyUI } =
  tpMileStoneUI

export interface IMinimalContainerJSON {
  _id: string
}

export const getShipmentPdadInfo = (tp: ITransportPlan2): ITransportPlanInformation => {
  // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
  const containersMock: IMinimalContainerJSON[] = tp.main.map((carriagePlan) => {
    return {
      _id: carriagePlan.trackables[0].trackableId,
    }
  })
  const containersPlans = getContainersPlans(tp, containersMock)
  const containerTp = getContainersTpSortedByActual(containersPlans)[0]

  const pdadMap = transformCarriagesToPdadMap(
    containerTp.origin,
    containerTp.pre,
    containerTp.main,
    containerTp.on,
    tp.transportType,
    tp.transportMode
  )

  const pdadSequence = getPdadSequence(pdadMap)
  const deliveryTimestamp = getPdadDeliveryTimestamp(pdadMap)
  const pdadDeliveryTimestamp = deliveryTimestamp
  const pdadDeliveryDate = deliveryTimestamp ? formatMomentShort(deliveryTimestamp.date) : null
  const pdadDeliveryEvents =
    tp.on &&
    tp.on.map((on) => {
      return on.events[getPdadEventCode(PDAD_DELIVERY, tp.transportType, tp.transportMode)]
    })
  return {
    tp,
    pdadMap,
    pdadSequence,
    pdadDeliveryTimestamp,
    // @ts-expect-error TS(2322) FIXME: Type 'string | null' is not assignable to type 'st... Remove this comment to see the full error message
    pdadDeliveryDate,
    pdadDeliveryEvents,
  }
}

const getPdadSequence = (pdadMap: TProgressPdadMap): ProgressPdad[] => {
  // @ts-expect-error TS(2322) FIXME: Type '(ProgressPdad | undefined)[]' is not assigna... Remove this comment to see the full error message
  return PdadStepsSequence.map((stepName) => pdadMap[stepName]).filter((item) => item)
}

const getPdadDeliveryTimestamp = (pdadMap: TProgressPdadMap): ITimestampJSON => {
  // @ts-expect-error TS(2322) FIXME: Type 'ITimestampJSON | undefined' is not assignabl... Remove this comment to see the full error message
  return pdadMap && pdadMap.delivery && pdadMap.delivery.event && pdadMap.delivery.event.aggregatedTimestamp
}

const transformCarriagesToPdadMap = (
  origin: ICargoProcess,
  pre: ICarriagePlan,
  main: ICarriagePlan,
  on: ICarriagePlan,
  transportType: TTransportType,
  transportMode: TTransportOrCarriageMode
): TProgressPdadMap => {
  const milestones = getAllMilestones([pre, main, on])
  const pdadMilestones = getPdadMilestones(milestones, main)
  const events = getAllEvents([origin, pre, main, on])
  const pdadEvents = getPdadEvents(pdadMilestones, events, transportType, transportMode)

  const pdadMap: TProgressPdadMap = {
    cargoReady: getProgressPdad(CARRIAGE_TYPE_PRE, cargoReadyUI, pdadEvents.cargoReady),
    pickup: getProgressPdad(CARRIAGE_TYPE_PRE, pickupUI, pdadEvents.pickup),
    departure: getProgressPdad(
      CARRIAGE_TYPE_MAIN,
      transportMode === 'air' ? departureAirportUI : departurePolUI,
      pdadEvents.departure
    ),
    arrival: getProgressPdad(
      CARRIAGE_TYPE_MAIN,
      transportMode === 'air' ? destinationAirportUI : arrivalPodUI,
      pdadEvents.arrival
    ),
    delivery: getProgressPdad(CARRIAGE_TYPE_ON, deliveryUI, pdadEvents.delivery),
  }

  return pdadMap
}
